/* Pereski 2026 · interactions des sections pk-* (vanilla, sans dépendance).
   Chaque section se ré-initialise quand on la modifie dans l'éditeur de thème. */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Apparition au défilement ---------- */
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        });
      }, { threshold: 0.16, rootMargin: "0px 0px -6% 0px" })
    : null;
  const observeReveal = (root) => {
    $$(".pk-reveal, .pk-timeline, .pk-exploded", root).forEach((el) => {
      if (designMode || !io) el.classList.add("is-in");
      else io.observe(el);
    });
  };

  /* ---------- Son partagé : une seule carte joue à la fois ---------- */
  const audio = new Audio();
  audio.preload = "none";
  let playingEl = null;
  const stopAll = () => {
    audio.pause();
    if (playingEl) playingEl.classList.remove("is-playing");
    playingEl = null;
  };
  const playFor = (host, src) => {
    if (!src) return;
    if (playingEl === host) { stopAll(); return; }
    stopAll();
    audio.src = src;
    audio.play().then(() => { host.classList.add("is-playing"); playingEl = host; }).catch(() => {});
  };
  audio.addEventListener("ended", stopAll);

  /* ---------- En-tête ---------- */
  const initHeader = (root) => {
    const header = $(".pk-site-header", root);
    if (!header || header.dataset.ready) return;
    header.dataset.ready = "1";
    const onScroll = () => header.classList.toggle("is-scrolled", scrollY > 24);
    addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    const nav = $(".pk-mnav", root);
    const open = $(".pk-burger", root);
    if (nav && open) {
      const setOpen = (v) => {
        nav.classList.toggle("is-open", v);
        open.setAttribute("aria-expanded", String(v));
        document.documentElement.style.overflow = v ? "hidden" : "";
      };
      open.addEventListener("click", () => setOpen(true));
      $$("[data-pk-close]", nav).forEach((b) => b.addEventListener("click", () => setOpen(false)));
      addEventListener("keydown", (e) => { if (e.key === "Escape") setOpen(false); });
    }
  };

  /* ---------- Hero : distribution des cartes + parallaxe ---------- */
  const initHero = (root) => {
    const fan = $(".pk-fan", root);
    if (!fan) return;
    setTimeout(() => fan.classList.add("is-dealt"), designMode ? 0 : 250);
    const stage = $(".pk-hero-stage", root);
    if (stage && !reduce && matchMedia("(pointer: fine)").matches) {
      stage.addEventListener("pointermove", (e) => {
        const r = stage.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        fan.style.transform = `rotateY(${x * 14}deg) rotateX(${-y * 10}deg)`;
      });
      stage.addEventListener("pointerleave", () => { fan.style.transform = ""; });
    }
  };

  /* ---------- Sons : bascule Animaux / Cocons + lecture ---------- */
  const initSounds = (root) => {
    $$(".pk-sound-switch", root).forEach((sw) => {
      const wrap = sw.closest("[data-pk-sounds]");
      sw.addEventListener("click", (e) => {
        const b = e.target.closest("button");
        if (!b) return;
        stopAll();
        sw.dataset.col = b.dataset.col;
        $$("button", sw).forEach((x) => x.classList.toggle("is-on", x === b));
        $$("[data-pk-col]", wrap).forEach((g) => { g.hidden = g.dataset.pkCol !== b.dataset.col; });
      });
    });
  };

  /* ---------- Comparateur avant / après ---------- */
  const initCompare = (root) => {
    $$(".pk-compare", root).forEach((cmp) => {
      const range = $(".pk-compare-range", cmp);
      const setPos = (v) => cmp.style.setProperty("--pk-pos", v + "%");
      range.addEventListener("input", () => { cmp.classList.add("is-touched"); setPos(range.value); });
      if (reduce || designMode || !io) return;
      new IntersectionObserver(([e], obs) => {
        if (!e.isIntersecting) return;
        obs.disconnect();
        const keys = [50, 82, 22, 50];
        let k = 0;
        const step = () => {
          if (cmp.classList.contains("is-touched") || k >= keys.length) { cmp.classList.remove("is-gliding"); return; }
          cmp.classList.add("is-gliding");
          setPos(keys[k]); range.value = keys[k]; k++;
          setTimeout(step, 1100);
        };
        setTimeout(step, 600);
      }, { threshold: 0.6 }).observe(cmp);
    });
  };

  /* ---------- Fiche produit ---------- */
  const initProduct = (root) => {
    const thumbs = $(".pk-thumbs", root);
    if (thumbs) {
      const main = $(".pk-stage-main img", root);
      thumbs.addEventListener("click", (e) => {
        const b = e.target.closest("button");
        if (!b || b.classList.contains("is-on")) return;
        $$("button", thumbs).forEach((x) => x.classList.toggle("is-on", x === b));
        main.classList.add("is-leaving");
        setTimeout(() => {
          main.onload = () => main.classList.remove("is-leaving");
          main.srcset = b.dataset.srcset || "";
          main.src = b.dataset.src;
          main.alt = b.dataset.alt || main.alt;
        }, 260);
      });
    }

    const form = $("product-form form", root);
    const idInput = form && $("[name=id]", form);

    // Quantité
    $$(".pk-qty", root).forEach((q) => {
      const input = $("input", q);
      q.addEventListener("click", (e) => {
        const b = e.target.closest("button[data-step]");
        if (!b) return;
        e.preventDefault();
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
      });
    });

    // Bascule vers le Duo : on change la variante ajoutée au panier
    const upsell = $(".pk-upsell", root);
    if (upsell && idInput) {
      const priceEl = $(".pk-buy .pk-price-row .pk-price", root);
      const lbl = $(".pk-atc > span", root);
      const stickyP = $(".pk-sticky-atc .pk-p", root);
      const base = { id: idInput.value, price: priceEl.innerHTML, label: lbl.textContent, sp: stickyP && stickyP.textContent };
      upsell.addEventListener("click", () => {
        const on = upsell.classList.toggle("is-on");
        upsell.setAttribute("aria-pressed", String(on));
        idInput.value = on ? upsell.dataset.variant : base.id;
        priceEl.innerHTML = on ? upsell.dataset.priceHtml : base.price;
        lbl.textContent = on ? upsell.dataset.label : base.label;
        if (stickyP) stickyP.textContent = on ? upsell.dataset.price : base.sp;
      });
    }

    // Barre d'achat collante
    const sticky = $(".pk-sticky-atc", root);
    const anchor = $(".pk-buy .pk-atc", root);
    if (sticky && anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => {
        sticky.classList.toggle("is-on", !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
      $("button", sticky).addEventListener("click", (e) => {
        e.preventDefault();
        if (form) form.requestSubmit ? form.requestSubmit() : anchor.click();
      });
    }
  };

  /* ---------- Cartes recto verso ---------- */
  const initDeck = (root) => {
    $$(".pk-deck-grid", root).forEach((grid) => {
      grid.addEventListener("click", (e) => {
        const flip = e.target.closest(".pk-flip");
        if (!flip) return;
        if (e.target.closest(".pk-mini-play")) { playFor(flip, flip.dataset.sound); return; }
        flip.classList.toggle("is-flipped");
      });
    });
  };

  /* ---------- Lecture des cartes (section sons) ---------- */
  document.addEventListener("click", (e) => {
    const card = e.target.closest(".pk-sound-card[data-sound]");
    if (card) { e.preventDefault(); playFor(card, card.dataset.sound); }
  });

  /* ---------- Bandeau : rotation des messages sur petits écrans ---------- */
  const initAnnounce = (root) => {
    $$("[data-pk-announce]", root).forEach((bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = "1";
      const msgs = $$(".pk-announce-msg", bar);
      if (msgs.length < 2 || reduce) return;
      let i = 0, paused = false;
      bar.addEventListener("mouseenter", () => (paused = true));
      bar.addEventListener("mouseleave", () => (paused = false));
      setInterval(() => {
        if (paused || document.hidden || !matchMedia("(max-width: 1100px)").matches) return;
        msgs[i].classList.remove("is-current");
        i = (i + 1) % msgs.length;
        msgs[i].classList.add("is-current");
      }, 4200);
    });
  };

  /* ---------- Vidéo ---------- */
  const initFilm = (root) => {
    $$("[data-pk-film]", root).forEach((frame) => {
      if (frame.dataset.ready) return;
      frame.dataset.ready = "1";
      const stage = frame.closest("[data-pk-film-stage]");
      const section = frame.closest(".pk-film");

      // YouTube allégé : l'iframe (youtube-nocookie) n'est chargée qu'au clic
      const yt = $("[data-yt]", frame);
      if (yt) {
        yt.addEventListener("click", () => {
          const f = document.createElement("iframe");
          f.src = `https://www.youtube-nocookie.com/embed/${yt.dataset.yt}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
          f.title = yt.getAttribute("aria-label") || "Vidéo";
          f.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
          f.allowFullscreen = true;
          yt.replaceWith(f);
        }, { once: true });
        return;
      }

      const video = $("video", frame);
      if (!video) return;
      const start = parseFloat(frame.dataset.start) || 0;
      const end = parseFloat(frame.dataset.end) || 0;
      const pickSrc = () => {
        const w = innerWidth * Math.min(devicePixelRatio || 1, 2);
        if (innerWidth < 821) return frame.dataset.srcSd;
        return w > 1900 ? frame.dataset.srcFhd : frame.dataset.srcHd;
      };
      let loaded = false, userPaused = reduce;
      const setPaused = (p) => {
        frame.classList.toggle("is-paused", p);
        const b = $("[data-film-play]", frame);
        if (b) b.setAttribute("aria-label", p ? "Lire la vidéo" : "Mettre la vidéo en pause");
      };
      const play = () => {
        if (!loaded) {
          loaded = true;
          video.src = pickSrc();
          video.preload = "auto";
          if (start) video.addEventListener("loadedmetadata", () => { video.currentTime = start; }, { once: true });
        }
        video.play().then(() => { frame.classList.add("is-ready"); setPaused(false); }).catch(() => setPaused(true));
      };
      // Boucle sur la partie lumineuse (la fin du fichier s'assombrit)
      if (end) video.addEventListener("timeupdate", () => { if (video.currentTime >= end) video.currentTime = start; });
      setPaused(true);

      if ("IntersectionObserver" in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && !userPaused) play();
            else if (!e.isIntersecting && !video.paused) video.pause();
          });
        }, { threshold: 0.25 }).observe(frame);
      } else if (!userPaused) play();

      $("[data-film-play]", frame)?.addEventListener("click", () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); setPaused(true); }
      });
      $("[data-film-sound]", frame)?.addEventListener("click", (ev) => {
        const on = video.muted;
        video.muted = !on;
        frame.classList.toggle("is-sound", on);
        ev.currentTarget.setAttribute("aria-pressed", String(on));
        ev.currentTarget.setAttribute("aria-label", on ? "Couper le son" : "Activer le son");
        if (on) { stopAll(); userPaused = false; play(); }
      });

      // Ouverture au défilement : la carte grandit et s'arrondit moins en entrant dans l'écran
      if (section && section.classList.contains("pk-film--cinema") && stage && !reduce && !designMode) {
        let ticking = false;
        const update = () => {
          ticking = false;
          const r = stage.getBoundingClientRect();
          const p = Math.min(1, Math.max(0, (innerHeight - r.top) / (innerHeight * 0.75)));
          stage.style.setProperty("--pk-film-p", p.toFixed(3));
        };
        addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
        update();
      }
    });
  };

  const init = (root = document) => {
    observeReveal(root);
    initAnnounce(root);
    initFilm(root);
    initHeader(root);
    initHero(root);
    initSounds(root);
    initCompare(root);
    initProduct(root);
    initDeck(root);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
  else init();
  document.addEventListener("shopify:section:load", (e) => { stopAll(); init(e.target); });
})();
